<script>
// import appConfig from '@src/app.config'
import { PersonApi, ApiPagedRequest } from '@chirhos/chirhos-api'
import { ChiRhos } from '@paladin/core'

const ChiRhosApi = new ChiRhos().api()
var personApi = new PersonApi(ChiRhosApi)

export default {
  page: {
    title: 'Notifications',
    // meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      notifications: {
        in: null,
        out: null,
      },
    }
  },
  mounted: function() {
    personApi
      .NotificationsIn({
        request: new ApiPagedRequest(1, 100, false),
      })
      .then(
        (response) => {
          // console.log(response.data)
          this.notifications.in = response.data
        },
        (error) => {
          console.error(error)
          this.$toast(error, 'error')
        }
      )
    personApi
      .NotificationsOut({
        request: new ApiPagedRequest(1, 100, false),
      })
      .then(
        (response) => {
          // console.log(response.data)
          this.notifications.out = response.data
        },
        (error) => {
          console.error(error)
          this.$toast(error, 'error')
        }
      )
  },
}
</script>

<template>
  <b-row>
    <b-col sm="12" md="6" lg="6">
      <b-card title="Received Notifications" sub-title="">
        <div v-if="notifications.in && notifications.in.length > 0">
          <div
            v-for="notification in notifications.in"
            :key="notification.entity.entityId"
          >
            <hr />
            <strong>Subject:</strong> {{ notification.entity.subject }}<br />
            <strong>Body:</strong> {{ notification.entity.bodyText }}<br />
            <strong>SMS Content:</strong> {{ notification.entity.shortMessage
            }}<br />
            <strong>Is notification:</strong>
            {{ notification.entity.isNotification }}
          </div>
        </div>
      </b-card>
    </b-col>
    <b-col sm="12" md="6" lg="6">
      <b-card title="Sent Notifications" sub-title="">
        <div v-if="notifications.out && notifications.out.length > 0">
          <div
            v-for="notification in notifications.out"
            :key="notification.entity.entityId"
          >
            <hr />
            <strong>Subject:</strong> {{ notification.entity.subject }}<br />
            <strong>Body:</strong> {{ notification.entity.bodyText }}<br />
            <strong>SMS Content:</strong> {{ notification.entity.shortMessage
            }}<br />
            <strong>Is notification:</strong>
            {{ notification.entity.isNotification }}
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
